<template>
    <div>
        <visualz name="ecomodal" width="100%" height="auto" :adaptive="true" :scrollable="true">
            <div class="bg-v-grey min-h-screen">
                <div class="bg-white shadow-lg w-full flex flex-row items-center flex-wrap-reverse md:flex-no-wrap justify-start flex-wrap">
                    <div class="flex items-center p-4 flex-wrap thnails justify-center w-full md:w-auto">
                        <img :class="active === 1 ? 'shadow-lg active' : ''"
                             @click="image(1)"
                             class="w-24 h-full mx-1 cursor-pointer p-1"
                             src="../../assets/refs/eco/ecotemp1-icon.jpg"
                             alt="">
                        <img :class="active === 2 ? 'shadow-lg active' : ''" @click="image(2)"
                             class="w-24 h-full mx-1 cursor-pointer p-1"
                             src="../../assets/refs/eco/ecotemp2-icon.jpg"
                             alt="">
                        <img :class="active === 3 ? 'shadow-lg active' : ''" @click="image(3)"
                             class="w-24 h-full mx-1 cursor-pointer p-1"
                             src="../../assets/refs/eco/ecotemp3-icon.jpg"
                             alt="">
                        <img :class="active === 4 ? 'shadow-lg active' : ''" @click="image(4)"
                             class="w-24 h-full mx-1 cursor-pointer p-1"
                             src="../../assets/refs/eco/ecotemp4-icon.jpg"
                             alt="">
                        <div class="divider h-16 ml-2 hidden md:block"></div>
                    </div>
                    <div class="flex flex-row justify-between flex-grow py-2">
                        <div class="flex flex-col justify-center ml-4 md:ml-0">
                            <h1 class="font-normal text-2xl">Ecotemp</h1>
                            <p class="font-light">logó és arculattervezés</p>
                        </div>

                        <div class="flex flex-row justify-end mr-6 items-center">
                            <svg class="cursor-pointer w-6 h-6 close" @click="$modal.hide('ecomodal')"
                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.56 16.56"><title>exit_1</title>
                                <g id="d2152467-9edf-429d-8b5c-813047a1f8ac" data-name="Layer 2">
                                    <g id="5f6f780c-3420-4b47-9f91-43f5a9007704" data-name="Layer 1">
                                        <path d="M16.41,15.7a.5.5,0,0,1,0,.71.49.49,0,0,1-.35.15.51.51,0,0,1-.36-.15L8.28,9,.86,16.41a.51.51,0,0,1-.36.15.49.49,0,0,1-.35-.15.5.5,0,0,1,0-.71L7.57,8.28.15.86a.5.5,0,0,1,0-.71.5.5,0,0,1,.71,0L8.28,7.57,15.7.15a.5.5,0,0,1,.71,0,.5.5,0,0,1,0,.71L9,8.28Z"/>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center bg-v-grey p-4">
                    <transition appear name="face">
                        <img v-if="active === 1" class="w-full h-full shadow-1"
                             src="../../assets/refs/eco/ecotemp1-max.jpg"
                             alt="">
                        <img v-else-if="active === 2" class="w-full h-full shadow-1"
                             src="../../assets/refs/eco/ecotemp2-max.jpg"
                             alt="">
                        <img v-else-if="active === 3" class="w-full h-full shadow-1"
                             src="../../assets/refs/eco/ecotemp3-max.jpg"
                             alt="">
                        <img v-else-if="active === 4" class="w-full h-full shadow-1"
                             src="../../assets/refs/eco/ecotemp4-max.jpg"
                             alt="">
                    </transition>
                </div>
            </div>
        </visualz>
    </div>
</template>

<script>
export default {
  name: 'ecomodal',
  data () {
    return {
      active: 1
    }
  },
  methods: {
    image (num) {
      this.active = num
    }
  }
}
</script>

<style lang="scss" scoped>
    .close {
        color: rgb(57, 82, 136);
        stroke: currentColor;
        stroke-width: 1px;
        fill: currentColor;
    }

    .shadow-1 {
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
    }

    .divider {
        border-left: 1px solid rgb(105, 174, 69);
    }
    .thnails > img:nth-child(n) {
        @media (max-width: 576px) {
            flex-basis: 33%;
        }
        @media (max-width: 768px) {

        }
        @media (max-width: 992px) {

        }
        @media (max-width: 1200px) {
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Modalz/ecomodal.vue